import { CSSProperties } from 'react';

import { M100RichTextLayout } from '~/lib/data-contract';

import styles from './textColumns.module.css';

export type TextColumnsProps = {
	columns: number;
	layout: M100RichTextLayout;
	children?: JSX.Element | JSX.Element[] | string | string[];
};

export const TextColumns = ({ children, columns }: TextColumnsProps) => {
	return (
		<div
			className={styles.root}
			style={{ '--text-columns-count': columns } as CSSProperties}
		>
			{children}
		</div>
	);
};
